import { lbAssays, type Assay } from '@zero-dash/types';

const ASSAY_LABELS: Partial<Record<Assay, string>> = lbAssays;

export const getAssayLabel = (assay?: string | null): string => {
  const key = assay?.trim();
  if (!key) {
    return '';
  }

  return ASSAY_LABELS[key as Assay] ?? key;
};
